import { marked } from 'marked';

// Plutonium's rich-text editor (EasyMDE) stores Markdown, so event bodies come
// back as Markdown source rather than HTML. Render it to HTML for display.
marked.setOptions({ gfm: true, breaks: true });

export const renderMarkdown = (markdown?: string | null): string =>
  markdown ? (marked.parse(markdown) as string) : '';
